// generated from 1_345_910 samples

import { z } from "zod";
import { common } from "../common";

export const sparseSegmentSchema = z.tuple([
  // null: 72 (0.01%)
  z
    .object({
      app_group_id: common.objectId,
      id: common.objectId,
      is_archived: z.boolean(),
      is_global_control: z.literal(false),
      name: z.string(),
      non_retargetable: z.boolean(),
      estimated_size: z.int().min(0).nullable().optional(),
    })
    .nullable(),
]);
